import React from 'react';
import PropTypes from 'prop-types';
import LaneContainer from '../UI/LaneContainer';
import { useTitle } from './containers/TitleDataStore';
import ConversationDrawer from '../Conversations/ConversationDrawer';
import ThreadSummary from '../Conversations/UI/ThreadSummary';
import ConversationType from '../Conversations/ConversationType';
import { useUser } from '../User/containers/UserDataStore';
import { useAccountOrMembershipRequiredModalContext } from '../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';

TitleConversations.propTypes = {
	sku: PropTypes.string,
	showSmallJacket: PropTypes.bool,
	isMobile: PropTypes.bool,
};

export default function TitleConversations({ sku, showSmallJacket, isMobile }) {
	const titleDataStore = useTitle();
	const { isAnonymous } = useUser();
	const { setIsVisible } = useAccountOrMembershipRequiredModalContext();

	const { conversations, title } = titleDataStore.state;

	const renderThreadSummary = () => (
		<ThreadSummary threads={conversations} doIncludeCommunities={true} />
	);

	const renderAnchor = () => {
		return isAnonymous() ? (
			<div className="clickable" onClick={() => setIsVisible(true)}>
				{renderThreadSummary()}
			</div>
		) : (
			<ConversationDrawer
				type={ConversationType.Title}
				id={sku}
				communityId={0}
				text={getConversationName()}>
				{renderThreadSummary()}
			</ConversationDrawer>
		);
	};

	const getConversationName = () => {
		return (
			<span>
				<span className="bold">{title.name}</span> by {title.author}
			</span>
		);
	};

	return (
		<LaneContainer
			majorHeader="Conversations"
			icon="chat"
			extra={
				!showSmallJacket && !isMobile ? (
					renderAnchor()
				) : (
					<React.Fragment />
				)
			}>
			{showSmallJacket || isMobile ? (
				<div style={{ marginBottom: '10px' }}>{renderAnchor()}</div>
			) : (
				<React.Fragment />
			)}
		</LaneContainer>
	);
}
